GroupTimelineService = ($http ,$q)  ->
  getTimeLines:(dParam) ->
    defer = $q.defer()
    url = "/api/groups/#{dParam.id}/timeline.json"
    $http.get(url, params: dParam ).then (resp) ->
      defer.resolve resp.data
    defer.promise

  submitReaction:(dParam) ->
    defer = $q.defer()
    url = "/api/users/reaction.json"
    $http.post(url , dParam).then (resp) ->
      defer.resolve resp.data
    defer.promise

GroupTimelineService.$inject = [
  '$http'
  '$q'
]

module.exports = GroupTimelineService



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/group-timeline/group-timeline-service.coffee